module.exports = "<div class=\"spinner\">\r\n      <div class=\"cover-spinner\"></div>\r\n      <div class=\"circular-spinner sk-circle\">\r\n            <md-spinner></md-spinner>\r\n      </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/app/shared/components/spinners/circular-spinner.component.html
// module id = ../../../../../src/app/shared/components/spinners/circular-spinner.component.html
// module chunks = main